import { MetricGroupId } from '../../../../../common/graphql/generated/graphql-sdk';
import {
  FrontendMetricGroupId,
  getMetricGroupIdFromFrontendMetricGroupId,
} from '../../../../../common/metrics/backendMetricMappings';
import { MetricStore } from '../../../../../common/metrics/metric-store';
import { recruitmentFrontendMetricGroups } from '../../../../../common/recruitment/recruitment-store';
import { Alias } from '../../../../../common/v2/api/alias/types';
import { Languages } from '../../../../../common/v2/constants';
import { BalanceSheetStore } from '../../balance-sheet-store';
import { PbsTableService } from '../../services/PbsTableService';

const name = 'people-balance-sheet';
const dashboardLinkKey = 'people-balance-sheet';

const initialCheckedPbsValues: MetricGroupId[] = [
  FrontendMetricGroupId.REVENUE_HC_MONTHLY,
  FrontendMetricGroupId.GROSS_PROFIT_HC_MONTHLY,
  FrontendMetricGroupId.OPERATING_PROFIT_AND_LOSS_HC_MONTHLY,
  FrontendMetricGroupId.NET_INCOME_HC_MONTHLY,
  FrontendMetricGroupId.SELLING_GENERAL_AND_ADMINISTRATION_HC_MONTHLY,
  FrontendMetricGroupId.TRAINING_COST_MONTHLY,
  FrontendMetricGroupId.INDIVIDUALS,
  FrontendMetricGroupId.JOINERS,
  FrontendMetricGroupId.LEAVERS_TERM_DATE,
  FrontendMetricGroupId.SPAN_OF_CONTROL,
  FrontendMetricGroupId.ATTRITION,
  FrontendMetricGroupId.THREE_MONTH_TENURE_ATTRITION,
  FrontendMetricGroupId.ONE_YEAR_TENURE_ATTRITION,
  FrontendMetricGroupId.FEMALE_HC,
  FrontendMetricGroupId.FEMALE_MANAGERS_CALCULATED,
  FrontendMetricGroupId.MANAGERS_CALCULATED,
  FrontendMetricGroupId.TENURE,
  FrontendMetricGroupId.SPAN_OF_CONTROL,
  FrontendMetricGroupId.DEPTH_OF_CONTROL,
  FrontendMetricGroupId.AGE,
  FrontendMetricGroupId.GENDER_PAY_GAP_MEDIAN_BASE,
  FrontendMetricGroupId.MONTHLY_OT,
  FrontendMetricGroupId.AVG_EMP_45_HRS_OT_PER_MONTH,
  FrontendMetricGroupId.AVG_WORK_HRS_PER_PERSON,
  FrontendMetricGroupId.NEW_MANAGERS_CALCULATED,
  FrontendMetricGroupId.RETENTION,
  FrontendMetricGroupId.INTERNAL_COMPA_RATIO,
  FrontendMetricGroupId.REGULAR_EMPLOYEE,
  FrontendMetricGroupId.NON_REGULAR_EMPLOYEE,
  FrontendMetricGroupId.TOTAL_WORKFORCE_COST,
  FrontendMetricGroupId.OVERTIME_PAY,
  FrontendMetricGroupId.TRAVEL_AND_COMMUTING,
].map((g) => getMetricGroupIdFromFrontendMetricGroupId(g));

const balanceSheetTableService = PbsTableService;

const recruitmentMetricGroupsSet = new Set(
  recruitmentFrontendMetricGroups.map((g) =>
    getMetricGroupIdFromFrontendMetricGroupId(g)
  )
);

const cypressConfiguredMetricGroups = [
  FrontendMetricGroupId.INDIVIDUALS,
  FrontendMetricGroupId.JOINERS,
  FrontendMetricGroupId.LEAVERS_TERM_DATE,
  FrontendMetricGroupId.AGE,
  FrontendMetricGroupId.SPAN_OF_CONTROL,
  FrontendMetricGroupId.FEMALE_HC,
  FrontendMetricGroupId.GENDER_PAY_GAP_MEDIAN_BASE,
].map((g) => getMetricGroupIdFromFrontendMetricGroupId(g));

const getNormalConfiguredMetricGroups = (
  metricStore: MetricStore
): MetricGroupId[] => {
  // Get all metric groups from metricTree and exclude recruitment metrics
  return metricStore.allMetricGroupIds.filter(
    (m) => !recruitmentMetricGroupsSet.has(m)
  );
};

export const getPeopleBalanceSheetStoreInstance = (
  metricStore: MetricStore,
  aliases: Alias[],
  selectedLanguage: Languages
) => {
  const configuredMetricGroups = window?.Cypress
    ? cypressConfiguredMetricGroups
    : getNormalConfiguredMetricGroups(metricStore);

  return new BalanceSheetStore(metricStore, aliases, selectedLanguage, {
    name,
    initialCheckedPbsValues,
    dashboardLinkKey,
    balanceSheetTableService,
    configuredMetricGroups,
  });
};
